module.exports = __webpack_public_path__ + "img/TR.0122ae62.svg";